import { render, staticRenderFns } from "./AddPolicy.vue?vue&type=template&id=35d37ccb&"
import script from "./AddPolicy.vue?vue&type=script&lang=js&"
export * from "./AddPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AddPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports